import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/admin/videos",
		component: lazy(() => import("./AdminVideosPage")),
	},
]);
